const t = "{{duration}} में से {{currentTime}}", A = "खोज नतीजे {{total}} में से {{current}}", n = "कोई नतीजा नहीं मिला", o = "{{count}} नतीजा मिला", E = "{{count}} नतीजे मिले", c = '$t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) और $t(SECONDS, { "count": {{seconds}} }) से चलाया जा रहा है।', T = '$t(MINUTES, { "count": {{minutes}} }) और $t(SECONDS, { "count": {{seconds}} }) से चलाया जा रहा है।', _ = '$t(SECONDS, { "count": {{seconds}} }) से चलाया जा रहा है।', s = "ट्रांसक्रिप्ट में बदलाव सेव करने में त्रुटि हुई।", S = "{{time}} पर ट्रांसक्रिप्ट लाइन। सामग्री इस प्रकार से है: {{text}}।", N = 'ट्रांसक्रिप्ट लाइन कंटेनर। इस कंटेनर में $t(TRANSCRIPT_LINES, { "count": {{count}} }) हैं। इस कंटेनर के भीतर नेविगेट करने के लिए नीचे तीर कुंजी का उपयोग करें।', R = "बदलाव सहेजे जा रहे हैं...", O = "ट्रांसक्रिप्ट में बदलाव सहेज लिए गए हैं।", I = "कैप्शन अपडेट करने का बटन अब उपलब्ध है।", C = "कार्यवाही", P = "{{time}} पर एनोटेशन जोड़ें", U = "{{time}} प्रश्न जोड़ें", L = "एनोटेशन", D = "स्वचालित", e = "स्वचालित ({{quality}})", M = "वापस जाएं", u = "कैप्शन", G = "कैप्शन भाषा", Y = "कैप्शन प्रबंधित करें", H = "{{language}} को मिटाएं", r = "फ़ॉन्ट साइज़", V = "कैप्शन भाषा: {{language}}", i = "{{language}} (स्वचालित)", B = "खोज साफ़ करें", a = "बंद करें", K = "टिप्पणियां", m = "जारी रखें", F = "प्लेबैक गति घटाएं", d = "वॉल्यूम को {{percent}}% से घटाएं", l = "नीचे तीर", h = "ट्रांसक्रिप्ट संपादक बंद करें", W = "कैप्शन अपडेट करें", $ = "त्रुटि!", g = "सहेजा जा रहा है...", Q = "सहेजा गया!", J = "ट्रांसक्रिप्ट संपादित करें", p = "पाठ खाली नहीं हो सकता!", x = "फ़ुलस्क्रीन", Z = "{{count}} घंटा", X = "{{count}} घंटे", f = "प्लेबैक गति बढ़ाएं", q = "वॉल्यूम को {{percent}}% से बढ़ाएं", v = "रंग विपरीत करें", y = "विशिष्ट प्रतिशत पर जंप करें (1-10%, 2-20%, आदि)", b = "शुरू करें पर जंप करें", j = "{{title}} के लिए कार्रवाइयां", k = "कुंजीपटल शॉर्टकट", w = "भाषा", z = "बायां तीर", tt = "मुख्य मेनू", At = "{{count}} मिनट", nt = "{{count}} मिनट", ot = "म्यूट करें", Et = "म्यूट किया गया", ct = "अगली कैप्शन भाषा", Tt = "खोज का अगला नतीजा", _t = "बंद", st = "सबसे ऊपर", St = "{{time}} पर एनोटेशन खोलें", Nt = "{{time}} पर पूरी की गई प्रश्नोत्तरी खोलें", Rt = "{{time}} पर प्रश्नोत्तरी खोलें", Ot = "पॉज़ करें", It = "चलाएं", Ct = "प्लेबैक गति", Pt = "प्लेबैक गति: {{speed}}x", Ut = "पिछली कैप्शन भाषा", Lt = "खोज का पिछला नतीजा", Dt = "गुणवत्ता", et = "क्वालिटी मेनू", Mt = "रीप्ले करें", ut = "प्लेबैक गति रीसेट करें", Gt = "दायां तीर", Yt = "ट्रांसक्रिप्ट खोजें", Ht = "{{count}} सेकंड", rt = "{{count}} सेकंड", Vt = "पीछे की ओर खोजें: {{seconds}} सेकंड", it = "आगे की ओर खोजें: {{seconds}} सेकंड", Bt = "सेटिंग्स", at = "शॉर्टकट", Kt = "मीडिया विवरण और उपकरण", mt = "स्पेस", Ft = "प्लेबैक गति मेनू", dt = "ऑटोस्क्रॉल शुरू करें", lt = "कैप्शन टॉगल करें", ht = "म्यूट किया गया टॉगल करें", Wt = "प्ले/पॉज़ टॉगल करें", $t = "{{count}} ट्रांसक्रिप्ट लाइन है", gt = "{{count}} ट्रांसक्रिप्ट लाइनें हैं", Qt = "ट्रांसक्रिप्ट लोड की जा रही है...", Jt = "हम ट्रांसक्रिप्ट लोड नहीं कर पाए।", pt = "ट्रांसक्रिप्ट विकल्प", xt = "फिर से कोशिश करें", Zt = "ट्रांसक्रिप्ट अनुपलब्ध है", Xt = "ऊपर तीर", ft = "वीडियो सेटिंग्स", qt = "वॉल्यूम", vt = "वॉल्यूम: {{volume}}%", yt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: A,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: o,
  A11Y_SEARCH_RESULTS_FOUND_other: E,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: T,
  A11Y_TIMESTAMP_JUMP_SECONDS: _,
  A11Y_TRANSCRIPT_ERROR: s,
  A11Y_TRANSCRIPT_LINE: S,
  A11Y_TRANSCRIPT_LINES: N,
  A11Y_TRANSCRIPT_SAVING: R,
  A11Y_TRANSCRIPT_SUCCESS: O,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: I,
  ACTION: C,
  ADD_ANNOTATION_AT: P,
  ADD_QUESTION_AT: U,
  ANNOTATIONS: L,
  AUTO: D,
  AUTO_QUALITY: e,
  BACK: M,
  CAPTIONS: u,
  CAPTIONS_LANGUAGE: G,
  CAPTIONS_MANAGE: Y,
  CAPTION_DELETE: H,
  CAPTION_FONT_SIZE: r,
  CAPTION_LANGUAGE: V,
  CAPTION_LANGUAGE_AUTOMATIC: i,
  CLEAR_SEARCH: B,
  CLOSE: a,
  COMMENTS: K,
  CONTINUE: m,
  DECREASE_PLAYBACK_SPEED: F,
  DECREASE_VOLUME: d,
  DOWN_ARROW: l,
  EDIT_CLOSE: h,
  EDIT_CONFIRM: W,
  EDIT_ERROR: $,
  EDIT_SAVING: g,
  EDIT_SUCCESS: Q,
  EDIT_TRANSCRIPT: J,
  EDIT_VALIDATION_ERROR: p,
  FULLSCREEN: x,
  HOURS: Z,
  HOURS_other: X,
  INCREASE_PLAYBACK_SPEED: f,
  INCREASE_VOLUME: q,
  INVERT_COLORS: v,
  JUMP_TO_PERCENTAGE: y,
  JUMP_TO_START: b,
  KEBAB_MENU: j,
  KEYBOARD_SHORTCUTS: k,
  LANGUAGE: w,
  LEFT_ARROW: z,
  MAIN_MENU: tt,
  MINUTES: At,
  MINUTES_other: nt,
  MUTE: ot,
  MUTED: Et,
  NEXT_CAPTION_LANGUAGE: ct,
  NEXT_HIT: Tt,
  OFF: _t,
  ON_TOP: st,
  OPEN_ANNOTATION_AT: St,
  OPEN_COMPLETED_QUIZ_AT: Nt,
  OPEN_QUIZ_AT: Rt,
  PAUSE: Ot,
  PLAY: It,
  PLAYBACK_SPEED: Ct,
  PLAYBACK_SPEED_MESSAGE: Pt,
  PREVIOUS_CAPTION_LANGUAGE: Ut,
  PREVIOUS_HIT: Lt,
  QUALITY: Dt,
  QUALITY_MENU: et,
  REPLAY: Mt,
  RESET_PLAYBACK_SPEED: ut,
  RIGHT_ARROW: Gt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Yt,
  SECONDS: Ht,
  SECONDS_other: rt,
  SEEK_BACKWARD: Vt,
  SEEK_FORWARD: it,
  SETTINGS: Bt,
  SHORTCUT: at,
  SIDEBAR: Kt,
  SPACE: mt,
  SPEED_MENU: Ft,
  START_AUTOSCROLL: dt,
  TOGGLE_CAPTIONS: lt,
  TOGGLE_MUTED: ht,
  TOGGLE_PLAY_PAUSE: Wt,
  TRANSCRIPT_LINES: $t,
  TRANSCRIPT_LINES_other: gt,
  TRANSCRIPT_LOADING: Qt,
  TRANSCRIPT_LOAD_ERROR: Jt,
  TRANSCRIPT_OPTIONS: pt,
  TRANSCRIPT_RETRY: xt,
  TRANSCRIPT_UNAVAILABLE: Zt,
  UP_ARROW: Xt,
  VIDEO_SETTINGS: ft,
  VOLUME: qt,
  VOLUME_VALUE: vt
};
export {
  t as A11Y_DURATION,
  A as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  o as A11Y_SEARCH_RESULTS_FOUND,
  E as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  T as A11Y_TIMESTAMP_JUMP_MINUTES,
  _ as A11Y_TIMESTAMP_JUMP_SECONDS,
  s as A11Y_TRANSCRIPT_ERROR,
  S as A11Y_TRANSCRIPT_LINE,
  N as A11Y_TRANSCRIPT_LINES,
  R as A11Y_TRANSCRIPT_SAVING,
  O as A11Y_TRANSCRIPT_SUCCESS,
  I as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  C as ACTION,
  P as ADD_ANNOTATION_AT,
  U as ADD_QUESTION_AT,
  L as ANNOTATIONS,
  D as AUTO,
  e as AUTO_QUALITY,
  M as BACK,
  u as CAPTIONS,
  G as CAPTIONS_LANGUAGE,
  Y as CAPTIONS_MANAGE,
  H as CAPTION_DELETE,
  r as CAPTION_FONT_SIZE,
  V as CAPTION_LANGUAGE,
  i as CAPTION_LANGUAGE_AUTOMATIC,
  B as CLEAR_SEARCH,
  a as CLOSE,
  K as COMMENTS,
  m as CONTINUE,
  F as DECREASE_PLAYBACK_SPEED,
  d as DECREASE_VOLUME,
  l as DOWN_ARROW,
  h as EDIT_CLOSE,
  W as EDIT_CONFIRM,
  $ as EDIT_ERROR,
  g as EDIT_SAVING,
  Q as EDIT_SUCCESS,
  J as EDIT_TRANSCRIPT,
  p as EDIT_VALIDATION_ERROR,
  x as FULLSCREEN,
  Z as HOURS,
  X as HOURS_other,
  f as INCREASE_PLAYBACK_SPEED,
  q as INCREASE_VOLUME,
  v as INVERT_COLORS,
  y as JUMP_TO_PERCENTAGE,
  b as JUMP_TO_START,
  j as KEBAB_MENU,
  k as KEYBOARD_SHORTCUTS,
  w as LANGUAGE,
  z as LEFT_ARROW,
  tt as MAIN_MENU,
  At as MINUTES,
  nt as MINUTES_other,
  ot as MUTE,
  Et as MUTED,
  ct as NEXT_CAPTION_LANGUAGE,
  Tt as NEXT_HIT,
  _t as OFF,
  st as ON_TOP,
  St as OPEN_ANNOTATION_AT,
  Nt as OPEN_COMPLETED_QUIZ_AT,
  Rt as OPEN_QUIZ_AT,
  Ot as PAUSE,
  It as PLAY,
  Ct as PLAYBACK_SPEED,
  Pt as PLAYBACK_SPEED_MESSAGE,
  Ut as PREVIOUS_CAPTION_LANGUAGE,
  Lt as PREVIOUS_HIT,
  Dt as QUALITY,
  et as QUALITY_MENU,
  Mt as REPLAY,
  ut as RESET_PLAYBACK_SPEED,
  Gt as RIGHT_ARROW,
  Yt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ht as SECONDS,
  rt as SECONDS_other,
  Vt as SEEK_BACKWARD,
  it as SEEK_FORWARD,
  Bt as SETTINGS,
  at as SHORTCUT,
  Kt as SIDEBAR,
  mt as SPACE,
  Ft as SPEED_MENU,
  dt as START_AUTOSCROLL,
  lt as TOGGLE_CAPTIONS,
  ht as TOGGLE_MUTED,
  Wt as TOGGLE_PLAY_PAUSE,
  $t as TRANSCRIPT_LINES,
  gt as TRANSCRIPT_LINES_other,
  Qt as TRANSCRIPT_LOADING,
  Jt as TRANSCRIPT_LOAD_ERROR,
  pt as TRANSCRIPT_OPTIONS,
  xt as TRANSCRIPT_RETRY,
  Zt as TRANSCRIPT_UNAVAILABLE,
  Xt as UP_ARROW,
  ft as VIDEO_SETTINGS,
  qt as VOLUME,
  vt as VOLUME_VALUE,
  yt as default
};
